import { set, get } from "lodash";
export const getPath = (key, obj) => {
    if (key === null) {
        return obj;
    }
    return get(obj, key);
};
export const setPath = (object, key, value) => {
    return set(object, key, value);
};
